<!-- Statistics -->
<div class="card p-5">

  <!-- Filters -->
  <div class="mt-2">
    <co-panel [config]="filterPanelConfig"> </co-panel>
  </div>
  <div class="border-t-1 border-gray-100 my-6"></div>

  <p-table
    [value]="skeletonRows"
    [scrollable]="true"
    scrollHeight="70vh"
    styleClass="skeleton-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 22px"></th>
        <th style="width: 22px"></th>
        @for(column of tableColumnsConfig(); track $index;){
          <th>{{ column.name | translate }}</th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body">
      <tr>
        <td style="width: 22px">
          <p-skeleton width="14px" height="14px" borderRadius="4px"></p-skeleton>
        </td>
        <td style="width: 22px">
          <p-skeleton width="14px" height="14px" borderRadius="9999px"></p-skeleton>
        </td>
        @for(column of tableColumnsConfig(); track $index;){
          <td>
            <p-skeleton width="80%" height="1rem"></p-skeleton>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</div>
